<template>
	<div class="close-valve-alarm-reason" v-if="detail.valveAlarmList && detail.valveAlarmList.length">
		<h3 class="diagnosis-title">触发关阀告警原因</h3>
		<div class="alarm-reason-list">
			<div
				class="alarm-reason"
				v-for="(item, index) in detail.valveAlarmList"
				:key="index"
				:class="{ fail: item.status === 2 }"
			>
				{{ item.title }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		detail: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
}
</script>
<style lang="scss" scoped>
.close-valve-alarm-reason {
	.alarm-reason-list {
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		gap: 6px;
		margin: 16px 0;
		.alarm-reason {
			line-height: 70px;
			text-align: center;
			border-radius: 4px;
			background-color: #f0f3fc;
			color: #2b57e8;
			font-size: 18px;
			font-weight: 600;
			&.fail {
				background-color: #e5662e1a;
				h5 {
					color: #e5662e;
				}
			}
		}
	}
}
</style>
